import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import AstrachatCampaignsAPI from '../../api/astrachat/campaigns';

const TYPES = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_RECORDS: 'SET_RECORDS',
  ADD_RECORD: 'ADD_RECORD',
  EDIT_RECORD: 'EDIT_RECORD',
  DELETE_RECORD: 'DELETE_RECORD',
  SET_AUDIENCE_PREVIEW: 'SET_AUDIENCE_PREVIEW',
  SET_READINESS_CHECK: 'SET_READINESS_CHECK',
};

export const state = {
  records: [],
  audiencePreview: null,
  readinessCheck: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingPreview: false,
    isFetchingReadiness: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAll: _state => _state.records,
  getById: _state => id =>
    _state.records.find(record => record.id === Number(id)),
  getAudiencePreview: _state => _state.audiencePreview,
  getReadinessCheck: _state => _state.readinessCheck,
};

export const actions = {
  get: async function getCampaigns({ commit }) {
    commit(TYPES.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await AstrachatCampaignsAPI.get();
      commit(TYPES.SET_RECORDS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(TYPES.SET_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCampaign({ commit }, campaignObj) {
    commit(TYPES.SET_UI_FLAG, { isCreating: true });
    try {
      const response = await AstrachatCampaignsAPI.create(campaignObj);
      commit(TYPES.ADD_RECORD, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(TYPES.SET_UI_FLAG, { isUpdating: true });
    try {
      const response = await AstrachatCampaignsAPI.update(id, updateObj);
      commit(TYPES.EDIT_RECORD, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(TYPES.SET_UI_FLAG, { isDeleting: true });
    try {
      await AstrachatCampaignsAPI.delete(id);
      commit(TYPES.DELETE_RECORD, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isDeleting: false });
    }
  },
  fetchAudiencePreview: async ({ commit }, data) => {
    commit(TYPES.SET_UI_FLAG, { isFetchingPreview: true });
    try {
      const response = await AstrachatCampaignsAPI.getAudiencePreview(data);
      commit(TYPES.SET_AUDIENCE_PREVIEW, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isFetchingPreview: false });
    }
  },
  fetchReadinessCheck: async ({ commit }, id) => {
    commit(TYPES.SET_UI_FLAG, { isFetchingReadiness: true });
    try {
      const response = await AstrachatCampaignsAPI.getReadinessCheck(id);
      commit(TYPES.SET_READINESS_CHECK, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(TYPES.SET_UI_FLAG, { isFetchingReadiness: false });
    }
  },
};

export const mutations = {
  [TYPES.SET_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [TYPES.SET_RECORDS]: MutationHelpers.set,
  [TYPES.ADD_RECORD]: MutationHelpers.create,
  [TYPES.EDIT_RECORD]: MutationHelpers.update,
  [TYPES.DELETE_RECORD]: MutationHelpers.destroy,
  [TYPES.SET_AUDIENCE_PREVIEW](_state, data) {
    _state.audiencePreview = data;
  },
  [TYPES.SET_READINESS_CHECK](_state, data) {
    _state.readinessCheck = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
